export default __webpack_public_path__ + "static/media/youthMusicProject2.d22613e4.png";